var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col w-full min-h-screen"},[_c('Menu'),_vm._v(" "),_c('Profile'),_vm._v(" "),_c('Posts'),_vm._v(" "),(_vm.hasConnections)?_c('Connections'):_vm._e(),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }